import { useState, useEffect } from "react";
import Chart from "chart.js/auto";
import { Pie } from "react-chartjs-2";
import { CategoryScale } from "chart.js";
import { TextInput, Slider } from "@mantine/core";
import { useForm } from "@mantine/form";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import "../index"

Chart.register(CategoryScale);
const Ratna = () => {
	const [value, setValue] = useState("Diamond");
	const formatter = new Intl.NumberFormat('en-IN', {
		style: 'currency',
		currency: 'INR',
		maximumFractionDigits: 2,
	  });
	  const formatter1 = new Intl.NumberFormat('en-IN', {
		style: 'currency',
		currency: 'INR',
		maximumFractionDigits: 0,
	  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  const nbsp = "\xa0";
	const form = useForm({
		initialValues: {
			installmentAmt: 10000,
			numInstallment: 11,
		
		},

		validate: {
			installmentAmt: (value) => (value <= 5000 ? null : "Amount must be greater than 0"),
		},
	});
	const getDiscount = () => {
		if (form.values.numInstallment < 8) {
			return 0;
		} else 
		if (form.values.numInstallment === 8){
			return (form.values.installmentAmt * 0.4);
		}
		else
		if(form.values.numInstallment === 9){
			return (form.values.installmentAmt * 0.6);
		}
		else if(form.values.numInstallment === 10){
			return (form.values.installmentAmt * 0.8);
		}
		else
		
			{
				return (form.values.installmentAmt * 1);
			}
		
	};
	const getDiamondDiscount = () => {
		if (form.values.numInstallment < 8) {
			return 0;
		} else 
		if (form.values.numInstallment === 8){
			return (form.values.installmentAmt * 0.4 *2);
		}
		else
		if(form.values.numInstallment === 9){
			return (form.values.installmentAmt * 0.6 * 2);
		}
		else if(form.values.numInstallment === 10){
			return (form.values.installmentAmt * 0.8 *2);
		}
		else
		
			{
				return (form.values.installmentAmt * 2);
			}
		
	};
	const getTotal =() => form.values.installmentAmt * form.values.numInstallment;
	const getDiscountPerc = () => (getDiscount() / getWorth() * 100);
	const getDiamondDiscountPerc = () =>(getDiamondDiscount() / getDiamondWorth() * 100);
	const getROI = () => (getDiscount() / (form.values.installmentAmt * form.values.numInstallment)) * 100;
	const getWorth = () => getDiscount() + form.values.installmentAmt * form.values.numInstallment;
	const getDiamondWorth = () => getDiamondDiscount() + form.values.installmentAmt * form.values.numInstallment;

	const getChartData = () => {
		const discountPerc = getDiscountPerc();
		const amountPayablePerc = 100 - discountPerc;
		const discount = getDiscount();
		const amount = getTotal();
		const Data = [
		
		  {
			label: `Benefit Offered (${formatter.format(discount)})`,
			amount: getDiscount(),
		  },
		  {
			label: `Amount Paid (${formatter.format(amount)})`,
			amount: getTotal(),
		  },
		 
		];

		return {
			labels: Data.map((data) => data.label),
			datasets: [
				{
					data: Data.map((data) => data.amount),
					backgroundColor: [ "#f6b800", "#c7931d",],
					borderColor: "#555",
					borderWidth: 2,
				},
			],
		};
	};

	const [chartData, setChartData] = useState(getChartData());

	useEffect(() => {
		setChartData(getChartData());
	}, [form.values.installmentAmt, form.values.numInstallment]);



	const getDiamondChartData = () => {
		const discountPerc = getDiamondDiscountPerc ();
		const amountPayablePerc = 100 - discountPerc;
	  const amt= getTotal();
	  const ddiscount = getDiamondDiscount();
	  console.log(ddiscount)
		const Data = [
			{
				label: `Benefit Offered (${formatter.format(ddiscount)})   `,
				amount: getDiamondDiscount(),
			  },
			{
				label: `Amount Paid (${formatter.format(amt)})   `,
				amount: getTotal(),
			  },
		
		 
		];

		return {
			labels: Data.map((data) => data.label),
			datasets: [
				{
					data: Data.map((data) => data.amount),
					backgroundColor: [ "#f6b800", "#c7931d",],
					borderColor: "#555",
					borderWidth: 2,
				},
			],
		};
	};

	const [chartDiamondData, setChartDiamondData] = useState(getDiamondChartData());

	useEffect(() => {
		setChartDiamondData(getDiamondChartData());
	}, [form.values.installmentAmt, form.values.numInstallment]);
	




	const divToShow = value === "Gold" ? (
		
		<div className="container-fluid">
				<div className="row">
				<div className="col-md-7">
				<table className="table table-striped">
<thead>
<tr>
<td>Total Amount Paid:</td>
<td><div className="bold" style={{ textAlign: "right" }}>{formatter.format(form.values.installmentAmt * form.values.numInstallment)}</div></td>

</tr>
</thead>
<tbody>
<tr>
<td>Benefit Offered:</td>
<td> <div className="bold" style={{ textAlign: "right" }}>{formatter.format(getDiscount())}</div></td>
</tr>

<tr>
<td>Redemption Value:</td>
<td><div className="bold" style={{ textAlign: "right" }}>{formatter.format(getWorth())}</div></td>
</tr>

</tbody>
</table>
					
					
					<div className="card">
  <div className="card-body">
  <b>Benefit:</b> <br></br>
  Effectively you get benefit worth <b>{formatter.format(getDiscount())}</b> in this example

  

  </div>


					{/* <div>
						<label>Effective Discount</label>
						<div className="bold">{getDiscountPerc().toFixed(2)}%</div>
					</div> */}

					{/* <div>
						<label>Effective Return on Investment</label>
						<div className="bold">{getROI()}%</div>
					</div>

					<div>
						<label>Annualized ROI</label>
						<div className="bold">{(getROI() * 12) / 6}%</div>
					</div> */}
				</div>
				<br></br>

				</div>

				<div className="col-md-5">
				<Pie data={chartData} height={128} width={128}/>
				</div>
		</div>
	</div>
		
	  ) : 
	  <div className="container-fluid">
	<div className="row">
	<div className="col-md-7">
	<table className="table table-striped">
<thead>
<tr>
<td>Total Amount Paid:</td>
<td><div className="bold" style={{ textAlign: "right" }}>{formatter.format(form.values.installmentAmt * form.values.numInstallment)}</div></td>

</tr>
</thead>
<tbody>
<tr>
<td>Benefit Offered:</td>
<td> <div className="bold" style={{ textAlign: "right" }}>{formatter.format(getDiamondDiscount())}</div></td>
</tr>

<tr>
<td>Redemption Value:</td>
<td><div className="bold" style={{ textAlign: "right" }}>{formatter.format(getDiamondWorth())}</div></td>
</tr>

</tbody>
</table>
			 
			  <div className="card">
  <div className="card-body">
  <b>Benefit:</b><br></br>
  Effectively you get benefit worth <b>{formatter.format(form.values.installmentAmt * 2)}</b> in this example
 

  </div>
  </div>
			 {/* <div>
				  <label>Effective Discount</label>
				  <div className="bold">{ getDiamondDiscountPerc().toFixed(2)}%</div>
			  </div> */}
		 

			  {/* <div>
				  <label>Effective Return on Investment</label>
				  <div className="bold"></div>
			  </div>

			  <div>
				  <label>Annualized ROI</label>
				  <div className="bold"></div>
			  </div> */}
			  <br></br>
			   
		  </div>

		  <div className="col-md-5">
		  <Pie data={chartDiamondData} height={128} width={128}/>
		  </div>
  </div>
  </div>
 

	
	return (
		<div className="page-content">
		<div className="container-fluid">
			
			
			<div className="row">
    <div className="col-md-4"><form onSubmit={form.onSubmit((values) => console.log(values))} >
					{/* <TextInput
						withAsterisk
						label="Installment Amount:"
						placeholder="1,00,000"
						{...form.getInputProps("installmentAmt")}s
					/> */}
					<div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
						<div style={{ display: "flex", justifyContent: "space-between" }}>
							<label>Installment Amount:</label>
							<div>{formatter1.format(form.values.installmentAmt)}</div>
						</div>
						
						<Slider {...form.getInputProps("installmentAmt")} min={5000} max={50000} step={1000} styles={(theme) => ({
		track: {
		  backgroundColor: '#f6b800', // Track color
		},
		thumb: {
		  backgroundColor: '#ffffff',
		  border: '4px solid #c7931d', // Thumb color
		},
		bar: {
		  backgroundColor: '#f6b800', // Color of the filled part
		},
	  })}/>
					</div>

				

					<div style={{ display: "flex", flexDirection: "column", gap: "3px" }}>
  <div style={{ display: "flex", justifyContent: "space-between" }}>
    <label>No. of Installments :</label>
    <div>{form.values.numInstallment}</div>
  </div>
  <div style={{ position: "relative", width: "100%" }}>
    <div
      style={{
        position: "absolute",
        width: "100%",
        height: "8px",
        background: "#f6b800",
        borderRadius: "5px",
        zIndex: 0,
      }}
    />
    <div
      style={{
        position: "absolute",
        width: "calc(100% * 11 / 11)", // This sets the width to 100% when the value is 11
        height: "8px",
        background: "#f6b800",
        borderRadius: "5px",
        zIndex: 1,
      }}
    />
    <input
      type="range"
      min={1}
      max={11}
      step={1}
      value={form.values.numInstallment}
      disabled // Disable the slider interaction
      style={{
        width: "100%",
        height: "8px",
        cursor: "default",
        opacity: 0,
        zIndex: 2,
      }}
    />
  </div>
</div>


					<div className="row" style={{paddingLeft: "10px"}}>
						<div className="col-md-6"><input type="radio" className="form-check-input" name="radio1" value="Diamond" checked={value === "Diamond"} onChange={handleChange} />
      {' '}<label style={{ paddingRight : "20px"}}>Diamond Jewellery </label> </div>
      <div className="col-md-6">
		<input type="radio" className="form-check-input"  name="radio1" value="Gold" checked={value === "Gold"} onChange={handleChange} />
      {' '}<label>Gold Jewellery</label>
	  </div>
	  
     
    </div>
	<br></br>
				</form>
				</div>
				<div className="col-md-8">{divToShow}</div>
				</div>
				
				<BrowserView>
				<div className="row indicator">
					<div className="col-md-3"></div>
					<div className="col-md-6"><p className="calculatorFor">
						<a href="/?scheme_name=samruddhi&show_menu=0&show_title=0" className="previous round" style={{color:"white"}}>&#8592;</a> Sample Calculator For <b className="jppName"> Ratna </b>
						<a href="/?scheme_name=golden-key&show_menu=0&show_title=0" className="next round" style={{color:"white"}}>&#8594;</a></p>  </div>
					<div className="col-md-3">
    <div className="card-body" style={{textAlign:"center"}}>
        <br/>

        <p style={{fontSize:"13px"}}>
            The benefits and other details shown above are only indicative.
        </p>

        For more details contact Bhima Helpline
        <a href="tel:1800-121-9076">1800-121-9076</a>
    </div>
</div>
</div>
				</BrowserView>
				<MobileView>
				<div className="row indicator">
					<div className="col-md-3"></div>
					<div className="col-md-6">
    <p style={{fontSize:"12px", color:"#777", textAlign:"center"}}>
        The benefits and other details shown above are only indicative.
    </p>

    <p className="calculatorFor">
        Sample Calculator For <b className="jppName">Ratna</b>
    </p>
</div>
					<div className="col-md-3"></div>
				</div>
				<div className="row indicator">
					<div className="col-md-5"></div>
					<div className="col-md-2" style={{textAlign:"center"}}>
					<a href="/?scheme_name=samruddhi&show_menu=0&show_title=0" className="previous round" style={{color:"white"}}>&#8592;</a>{nbsp}{nbsp}{nbsp}

					<a href="/?scheme_name=golden-key&show_menu=0&show_title=0" className="next round" style={{color:"white"}}>&#8594;</a></div>	
<div className="col-md-5"><div className="card-body" style={{textAlign: "center"}}><br />For more details contact Bhima Helpline<a href="tel:1800-121-9076">1800-121-9076</a></div></div>
				</div>
				</MobileView>
				
			</div>
		</div>
	);
}

export default Ratna;